export default "__VITE_ASSET__BhB7jRLl__"